import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import AppContainer from './AppContainer.js';
import store from './store/store.js';
import * as serviceWorker from './serviceWorker';


const rootElement = document.getElementById('root');
	
if (rootElement.hasChildNodes()) {
	hydrate(
		<Provider store={store}>
			<AppContainer />
		</Provider>, 
	rootElement);
} else {
	render(
		<Provider store={store}>
			<AppContainer />
		</Provider>, rootElement);
}


serviceWorker.unregister();
